import { useEffect, useState } from "react";
import { FaTimes } from "react-icons/fa";
import styled from "styled-components";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { userRequest } from "../requestMethods";
import { useNavigate } from "react-router-dom";
import { ImageUrl } from "../requestMethods";
import { getCartData, removeFromCart, emptyCart } from "../apiCalls/cart";
import Breadcrumb from "../components/Breadcrumb/Breadcrumb";

const ProductColor = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: ${(props) => props.color};
`;

const ProductSize = styled.span``;

const Cart = () => {
  const cart = useSelector((state) => state.cart.products);
  const user = useSelector((state) => state.user.currentUser);
  const [stripeToken, setStripeToken] = useState(null);
  const history = useNavigate();
  const dispatch = useDispatch();
  const [subTotalAmount, setSubTotalAmount] = useState(0);

  const onToken = (token) => {
    setStripeToken(token);
  };

  useEffect(() => {
    getCartData(dispatch, user?._id);
    console.log('running from there')
  }, [dispatch]);

  useEffect(() => {
    let proLi = cart[0]?.cartItems?.map(
      (product) => product?.productId?.price * product?.quantity
    );
    console.log(proLi, "proLi");
    parseInt(setSubTotalAmount(
      proLi?.reduce((partialSum, a) => partialSum + a, 0)
    ))
  }, [subTotalAmount, cart])

  useEffect(() => {
    const makeRequest = async () => {
      try {
        const res = await userRequest.post("/checkout/payment", {
          tokenId: stripeToken.id,
          amount: cart.total * 100,
        });
        history.push("/success", { data: res.data });
      } catch (err) {
        console.log("Err", err);
      }
    };
    stripeToken && cart.total >= 1 && makeRequest();
  }, [stripeToken, cart.total, history]);


  const handleRemoveFromCart = (cartId) => {
    removeFromCart(dispatch, user._id, cartId, successRemove);
  };

  const successRemove = (res) => {
    console.log("successfully removed");
  };

  const handleClearCart = () => {
    emptyCart(dispatch, user._id, successRemove)
  };

  return (
    <>
    <Breadcrumb activeName={"Cart"} middleName={""} middleUrl={""}/>
      <section className="cart-section">
        <div className="container">
          <div className="row">
            <div className="col-full">
              <div className="cart-content">
                <div className="cart-data">
                  <h3 className="cart-page-title title mb-1">
                    Cart items ({cart[0]?.cartItems?.length})
                  </h3>
                  <div className="table-data">
                    <table className="cart-table">
                      <thead>
                        <tr>
                          <th>Image</th>
                          <th>Product</th>
                          <th>Quantity</th>
                          <th>Total</th>
                          <th>Remove</th>
                        </tr>
                      </thead>
                      <tbody>
                        {cart[0]?.cartItems?.map((product, index) => (
                          <tr key={index}>
                            <td className="cart-image">
                              <Link to={`/product/${product?.productId?._id}`}>
                                <img
                                  src={
                                    `${ImageUrl}` +
                                    product?.productId?.mainImg[0]?.filename
                                  }
                                  width="120"
                                  height="120"
                                />
                              </Link>
                            </td>
                            <td className="cart-title">
                              <Link to={`/product/${product._id}`}>
                                <span className="cart-product-title">
                                  {product?.productId?.title}
                                </span>
                              </Link>
                              {/* <span>{product._id}</span> */}
                              <div className="product-cart-color">
                                <span>Color: </span>
                                <ProductColor color={product.color} />
                              </div>
                              <ProductSize>
                                <span className="cart-size">Size:</span>{" "}
                                {product.size}
                              </ProductSize>
                            </td>
                            <td className="cart-qty">
                              <span>{product?.quantity}</span>
                            </td>
                            <td className="cart-total">
                              <span>
                                {" "}
                                ₹ {product?.productId?.price * product?.quantity}
                              </span>
                            </td>
                            <td className="cart-action">
                              <FaTimes
                                className="close-icon"
                                onClick={() =>
                                  handleRemoveFromCart(product._id)
                                }
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="cart-more-action">
                    {/* <p className="clear-cart" onClick={() => handleClearCart()}>
                      Clear Cart &nbsp;
                    </p>   */}

                    <Link to="/products" className="btn">
                      continue shopping
                    </Link>
                  </div>
                </div>
                <div className="cart-total-summary">
                  <h2 className="cart-page-title title mb-1">ORDER SUMMARY</h2>

                  <ul className="cart-summary-list">
                    <li>
                      <span>Subtotal</span>
                      <span>₹ {subTotalAmount === NaN || subTotalAmount === undefined ? 0 : subTotalAmount}</span>
                    </li>

                    <li>
                      <span>Shipping Charges</span>
                      <span>₹ 0.00</span>
                    </li>

                    <li>
                      <span>Coupon Discount</span>
                      <span>₹ 0.00</span>
                    </li>

                    <li>
                      <span>Total Pay Amount</span>
                      <span>₹ {subTotalAmount === NaN || subTotalAmount === undefined ? 0 : subTotalAmount}</span>
                    </li>
                  </ul>

                  <button className="btn w-100">
                    {" "}
                    <Link to="/payment">Proceed to pay</Link>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Cart;
